module.exports = __webpack_public_path__ + "static/media/stats-3.61f7c143.svg";